import { observer } from 'mobx-react-lite';
import React from 'react'
import AppState from '../../../js/AppState';
import SoundPlayer from '../../../js/SoundPlayer';
import Texts from 'react-sdk/Texts';

import './Subtitle.css'

const Subtitle = ({className, text, character, isRight, onClick}) => {

  if(!AppState.subtitles_visible) return false

  function handleClick(e) {
    e.stopPropagation()

    SoundPlayer.playSound("click")
    if(onClick) onClick()
  }

  function handleMouseEnter() {
    SoundPlayer.playSound("rollOver")
  }

  let cn = "Subtitle"
  if(className)
    cn += " " + className 



  return (
    <div className={ cn } onClick={(e) => handleClick(e)} onMouseEnter={() => handleMouseEnter()}>
      {character && <span className={"name " + (isRight? " right" : "")}>{Texts.get(character)}</span>}
      <div dangerouslySetInnerHTML={{ __html: text}}></div>
    </div>
  );
};

export default observer(Subtitle)
